// extracted by mini-css-extract-plugin
module.exports = {"root":"Phone_root__MqUB_","image":"Phone_image__BtbP2"};